export default {
  'promotionManagement.title': '促销管理',
  'promotionManagement.section.quickAccess': '快捷创建',
  'promotionManagement.section.allPromotions': '所有促销',
  'promotionManagement.edit.title': '编辑促销',
  'promotionManagement.create.title': '新建促销',
  'promotionManagement.duplicate.title': '复制促销',
  'promotionManagement.section.generalInformation': '基本信息',
  'promotionManagement.section.usageRules': '使用规则',
  'promotionManagement.section.conditions': '条件',
  'promotionManagement.section.schedulingAndDuration': '日程安排 & 持续时间',
  'promotionManagement.column.number': '活动号',
  'promotionManagement.column.type': '活动类型',
  'promotionManagement.column.available_count': '库存',
  'promotionManagement.column.redeemed_count': '已使用',
  'promotionManagement.column.orders_total': '订单金额 ($)',
  'promotionManagement.column.orders_count': '订单数',
  'promotionManagement.column.promotions_total': '打折金额 ($)',
  'promotionManagement.column.promotion_display_status': '状态',
  'promotionManagement.column.action': '操作',
  'promotionManagement.column.created_at': '创建时间',
  'promotionManagement.column.updated_at': '最近更新时间',
  'promotionManagement.column.name': '促销名',
  'promotionManagement.column.foreign_name': '促销中文名',
  'promotionManagement.column.display_name': '显示名',
  'promotionManagement.column.display_name.tooltip': '显示在账单、收据、kiosk、扫码点餐以及平板点餐上',
  'promotionManagement.column.display_foreign_name': '中文显示名',
  'promotionManagement.column.description': '描述',
  'promotionManagement.column.description.tooltip': '显示在kiosk，扫码点餐以及平板点餐上',
  'promotionManagement.column.quantity': '总数量',
  'promotionManagement.column.quantity.description': '总促销份数量',
  'promotionManagement.column.unlimited': '不限',
  'promotionManagement.column.limit_per_order': '每单限用数量',
  'promotionManagement.column.limit_per_order.description': '每份订单限用促销次数',
  'promotionManagement.column.service_types': '服务类型',
  'promotionManagement.column.order_sources': '订单来源',
  'promotionManagement.column.customer_groups': '客户群体',
  'promotionManagement.column.customer_groups.description': '会员专享的促销目前仅应用于POS App。',
  'promotionManagement.column.promotion_type': '促销类型',
  'promotionManagement.column.purchase_item_quantity': '购买数量',
  'promotionManagement.column.offer_item_quantity': '获赠数量',
  'promotionManagement.column.max_offer_quantity': '折扣项目最大数量',
  'promotionManagement.column.amount_off': '打折金额',
  'promotionManagement.column.miminum_amount': '最低消费金额',
  'promotionManagement.eligibleItemsForDiscount': '享受折扣的项目',
  'promotionManagement.column.items_excluded_from_discount': '不享受折扣的项目',
  'promotionManagement.column.items_excluded_from_discount.description':
    '在菜单管理中排除的菜品不会在下面显示，并且它们也将继续排除在折扣之外。',
  'promotionManagement.seleceted.desc': '(已选中{count}项)',
  'promotionManagement.column.eligible_items_for_promotion': '符合促销的项目',
  'promotionManagement.column.eligible_purchase_items': '符合条件的购买项目',
  'promotionManagement.column.eligible_offer_items': '符合条件的优惠项目',
  'promotionManagement.column.eligible_offer_items.description': '最便宜的项目享受折扣',
  'promotionManagement.eligibleOfferItemsIdenticalAsEligiblePurchaseItems':
    '符合条件的优惠项目与符合条件的购买项目使用相同的集合',
  'promotionManagement.canOnlyBuyIdenticalPurchaseAndOfferItems': '客户只能获得与购买项目一致的优惠项目',
  'promotionManagement.column.start_date': '开始日期',
  'promotionManagement.column.end_date': '结束日期',
  'promotionManagement.column.start_time': '开始时间',
  'promotionManagement.column.days_of_week': '周内的某些天',
  'promotionManagement.column.end_time': '结束时间',
  'promotionManagement.rule.required': '发布要求必填字段',
  'promotionManagement.amount_off.required': '必须选择$ off 或 % off，并填写金额',
  'promotionManagement.customer_groups.all': '所有',
  'promotionManagement.customer_groups.loyalty_members': '会员',
  'promotionManagement.customer_groups.non_members': '非会员',
  'promotionManagement.items.required': '至少选择任意菜单里一个项目。',
  'promotionManagement.action.saveAsDraft': '保存为草稿',
  'promotionManagement.action.publish': '发布',
  'promotionManagement.items': '项目 ( {count} / {total} )',
  'promotionManagement.openPriceItemsExcluded': '排除开价菜',
  'promotionManagement.pointedItemsExcludes': '排除积分菜',
  'promotionManagement.excludedFromDiscount': '已在菜单管理中排除',
  'promotionManagement.autoPauseDesc': '活动商品已售完，活动已自动暂停，您可以再次编辑，提高活动限额后再次发布',

  'promotionManagement.searchByName': '按促销名搜索',
  'promotionManagement.error.start_date': '开始日期必须早于结束日期',
  'promotionManagement.error.end_date': '结束日期必须晚于开始日期',
  'promotionManagement.error.start_time': '开始时间必须早于结束时间',
  'promotionManagement.error.end_time': '结束时间必须晚于开始时间',
  'promotionManagement.orderSourcesForEligibleItems': '选择订单来源以选择符合条件的促销项目。',
  'promotionManagement.orderSourcesForExcludedItems': '选择订单来源以选择不参与促销的项目。',
  'promotionManagement.saveAsDraftSuccess': '成功保存促销！别忘了点击发布',
  'promotionManagement.publishedSuccess': '成功发布促销',
  'promotionManagement.deletePromotion': `
    确认要删除“{promotionName}”这个促销吗?\n此促销将被立即删除且不能撤销。
  `,
  'promotionManagement.displayPromotionsAsTheFirstCategory': '创建促销分类并将其展示为第一个分类',
  'promotionManagement.displayPromotionsAsTheFirstCategory.description': `
      <p>
        系统将自动创建一个参与菜品级促销的分类
      </p>
      <p style="margin-bottom: 0;">
        将其展示在自助点餐机、扫码点餐及平板点餐上
      </p>
    `,
  'promotionManagement.failedToLoadDishes': '加载菜品失败',
  'promotionManagement.singlePromotionAtTheSameTime': '请不要在同一时间段设置多个促销活动。',
  'promotionManagement.cannotCreatePromotion.title': '无法创建新的促销活动',
  'promotionManagement.existConflicts.title': '时间段存在冲突',
};
